module.exports = __webpack_public_path__ + "static/media/imagemNull.66440440.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/ServiceBox2/imagemNull.jpg
// module id = 622
// module chunks = 0 1 2 3 7 8